import { TokenResponse, CodeResponse } from '@react-oauth/google';

const isOnLineGmail = (response: TokenResponse | CodeResponse): response is TokenResponse => {
  return (response as TokenResponse).access_token !== undefined;
};

export default isOnLineGmail;
